export function useDownloadLink(href, params = {}) {
  const userAgent = window.navigator.userAgent;
  const target = (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) ? '_self' : '_blank';

  let defaultParams = {
    target: target,
    href: href
  };

  Object.assign(
      document.createElement('a'),
      Object.assign(defaultParams, params)
  ).click();
}
export function useDownloadResponse(response, fileName, params = {}) {
  const userAgent = window.navigator.userAgent;
  const href = window.URL.createObjectURL(new Blob([response.data]));
  const target = (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) ? '_self' : '_blank';

  let defaultParams = {
    download: fileName,
    href: href,
    target: target,
  };

  Object.assign(
      document.createElement('a'),
      Object.assign(defaultParams, params)
  ).click();
}